// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Section-Side-module--cls1--18i2Z","cls2":"Section-Side-module--cls2--1vyCe Section-Side-module--cls1--18i2Z"};